var styleDataHash = "130e164c";
const injectCss = () => {
  var css = `.N30eu{--wds-button-size-small:36px;--wds-color-picker-padding-vertical:12px 0px;--wds-color-picker-padding-horizontal:6px 0px;--wds-color-picker-width:100%}.-rn6C{--wds-side-panel-footer-padding-horizontal:18px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var custom_color_picker_default = {
  "customPicker": "N30eu",
  "header": "-rn6C"
};
export {
  custom_color_picker_default as default,
  injectCss
};
//# sourceMappingURL=custom-color-picker-scss.js.map
